import { sanitizePath } from "./sanitizePath";

const isDev = process.env.NODE_ENV !== "production";

const hasGtag = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

// Current page as GA4 should see it: origin + route template, never the real
// path (checkout URLs carry a token). Query string and hash are dropped too.
const safePageLocation = () =>
  typeof window !== "undefined"
    ? `${window.location.origin}${sanitizePath(window.location.pathname)}`
    : "";

export const gaEvent = (eventName, params = {}) => {
  // gtag attaches the raw document location to every event unless the event
  // itself carries page_location (event-level params win over config-level).
  const payload = { page_location: safePageLocation(), ...params };
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(`[GA4] event: ${eventName}`, payload);
  }
  if (!hasGtag()) return;
  window.gtag("event", eventName, payload);
};

export const gaPageView = (path) => {
  // page_location is rebuilt from the (already sanitised) path rather than
  // window.location.href, so route params such as checkout tokens never
  // reach GA4.
  const payload = {
    page_path: path,
    page_location:
      typeof window !== "undefined" ? `${window.location.origin}${path}` : "",
    page_title: typeof document !== "undefined" ? document.title : "",
  };
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(`[GA4] page_view: ${path}`, payload);
  }
  if (!hasGtag()) return;
  window.gtag("event", "page_view", payload);
};
